import { render, staticRenderFns } from "./CustomBags.vue?vue&type=template&id=030631b4&scoped=true"
import script from "./CustomBags.vue?vue&type=script&lang=js"
export * from "./CustomBags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030631b4",
  null
  
)

export default component.exports